import React from 'react'
import Layout from '@/components/Common/Layout'
import SEO from '@/components/Common/Seo'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import { Blocks, Head } from '@/components/WordPress'
import { WpContent } from '@/styles/Layout'
import { commonParagraph } from '@/styles/Typography'
import EmbedPlayerTop from '@/components/Common/EmbedPlayerTop'
import PostHeader from '@/components/Featured/Mundial62/Posts/PostHeader'
import PostFooter from '@/components/Featured/Mundial62/Posts/PostFooter'

const FeaturedWpContent = styled(WpContent)`
  p {
    ${commonParagraph}
    text-align: justify;
    text-indent: 2rem;
    padding-bottom: 2rem;
  }
`

const IndexPage = ({
  data: {
    wpPost: {
      excerpt,
      featuredImage,
      title,
      rawContent,
      slug,
      videofields: { iframe },
      formatFields: { posttitle, pretitle },
      metaFields: { author, authorsite, authorsiteurl },
      date,
    },
    site: {
      siteMetadata: { baseUrl, baseTitle },
    },
  },
}) => {
  return (
    <Layout>
      <SEO />
      {iframe && <EmbedPlayerTop iframe={iframe} />}
      <PostHeader
        layout="large"
        title={title}
        pretitle={pretitle}
        posttitle={posttitle}
        author={author}
        authorsite={authorsite}
        authorsiteurl={authorsiteurl}
        date={date}
        slug={slug}
        featuredImage={featuredImage}
        excerpt={excerpt}
        withPostImage={false}
      />
      <FeaturedWpContent>
        <Blocks raw={rawContent} />
      </FeaturedWpContent>
      <PostFooter />
    </Layout>
  )
}

export default IndexPage

export const postQuery = graphql`
  query PostVideoQuery($id: String!) {
    wpPost(id: { eq: $id }) {
      id
      title
      content
      rawContent
      excerpt
      slug
      date
      videofields {
        iframe
      }
      featuredImage {
        node {
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 1920
                placeholder: BLURRED
                formats: [WEBP, AVIF]
              )
            }
          }
        }
      }
      formatFields {
        posttitle
        pretitle
      }
      metaFields {
        author
        authorsite
        authorsiteurl
      }
    }
    site {
      siteMetadata {
        baseUrl: url
        baseTitle: title
      }
    }
  }
`
